@if (objectViewData) {
  <div class="object-view">
    @for (section of objectViewData.sections; track section.name) {
      <div
        class="object-view__section"
        id="section-{{section.name}}"
        [ngClass]="{'withSection': !hideSectionTitle}"
      >
        <div class="object-view__section-content">
          @if (!hideSectionTitle) {
            <app-object-view-section-title
              [showRestrictedIndicator]="sectionShouldHaveRestrictionIndicator(section)"
              [title]="section.title"
            />
          }

          <div class="object-view__section-field-container">
            @for (sectionField of section.section_fields; track sectionField.field_name) {
              <div
                class="object-view__section-field"
                [ngClass]="{'object-view__action-buttons': sectionField.action_button}"
              >
                <div class="object-view__field">
                  @if (!sectionField.action_button) {
                    <app-display-field-title
                      [titleClass]="section.name === 'user_rights' ? 'user-rights': ''"
                      [field]="sectionField"
                    ></app-display-field-title>
                  }

                  @if (sectionField.items) {
                    <ng-container>
                      @for (item of sectionField.items; track $index) {
                        <ng-container>
                          @if ($index < 10 || sectionField.$$showAll) {
                            <div
                              class="object-view__field-content"
                              [ngClass]="{'user-rights': section.name === 'user_rights',
                                          'level-1': item.header_values && item.header_values.level === 1,
                                          'level-2': item.header_values && item.header_values.level === 2,
                                          'new-array-item': item.is_new_array_item}"
                            >
                              @if (item.header_values) {
                                <div
                                  class="item-header"
                                  [ngClass]="{'bold': item.header_values.level === 1}"
                                >
                                  <app-object-view-field-values
                                    [fieldValues]="item.header_values"
                                    [sectionsContainer]="sectionsContainer"
                                  ></app-object-view-field-values>
                                </div>
                              }

                              <app-object-view-field-checkbox
                                [sectionsContainer]="sectionsContainer"
                                [checkboxField]="item.checkbox_field"
                              >
                                @if (item.field_values) {
                                  <app-object-view-field-values
                                    [fieldValues]="item.field_values"
                                    [sectionsContainer]="sectionsContainer"
                                  ></app-object-view-field-values>
                                }
                              </app-object-view-field-checkbox>
                            </div>
                          }
                        </ng-container>
                      }

                      <app-object-view-show-more
                        [field]="sectionField"
                      ></app-object-view-show-more>
                    </ng-container>
                  }

                  @if (sectionField.action_button) {
                    <div>
                      <app-field-action-button
                        class="section-field__action-button"
                        [sectionsContainer]="sectionsContainer"
                        [fieldTitle]="sectionField.title"
                        [field]="sectionField.action_button"
                      ></app-field-action-button>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
